import axios from "axios";
const baseUrl =
  "https://53fde1b606cff91e7a3b23ff9c242152.grupoalianzacolombia.com/upload.php";

// Lanzamos el error sin tragárnoslo: axios conserva error.response
// (status y data) para que el front pueda mostrar al cliente los mensajes
// de error que devuelve la API de subida (400/404/405/413/415/500...).
const uploadFileGac = async (image) => {
  const response = await axios.post(baseUrl, image);
  return response;
};

export { uploadFileGac };